import React from 'react'
import { withIcon } from '../../withIcon'

function PlayPreviewOutlineIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 25">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.625 7.25V17.25H20.375V7.25H3.625ZM2.375 6.97392C2.375 6.39418 2.86471 6 3.37473 6H20.6253C21.1353 6 21.625 6.39418 21.625 6.97392V17.5261C21.625 18.1043 21.1361 18.5 20.6253 18.5H3.37473C2.86387 18.5 2.375 18.1043 2.375 17.5261V6.97392Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M14.7368 12.3358L10 14.7519V9.91974L14.7368 12.3358Z" fill={color}/>
    </svg>
  )
}

export default withIcon(PlayPreviewOutlineIcon)
